export enum ExploraEntries {
  Home = '4KdBfwJGfJHrOLnxUuHTsj',
  Production = '3Mxy256dkvkOSL6Uc7ziVx',
  Us = '4gPHvA1Y7KAZmiaAF3ktlx',
  Blog = '1HICr1Tee5TtWJ791Xjl9s'
}
